<template>
    <div class="content-wrapper">
        <PageHeader :screenName="form.descricao" :linkItems="linkItems" />

        <ErrorModal :modalShow="modalError.showModal" :typeModal="modalError.typeModal"
            :caseModal="modalError.caseModal" @confirmed="redirecionarLista" />

        <main class="card p-2 centralizar_responsivo">
            <section class="form">
                <b-form>
                    <div class="top-right-button">
                        <b-button class="d-flex align-items-center" @click="$router.back()" variant="primary-button">
                            <feather-icon icon="ArrowLeftIcon" class="mr-50" />
                            <span class="align-middle">Voltar</span>
                        </b-button>
                    </div>
                    <b-row>
                        <b-col lg="8" md="6" sm="6">
                            <b-form-group label="Nome da Dose" label-for="descricao"
                                label-class="label_size_dose font-weight-bold">
                                <vue-perfect-scrollbar class="altura_max_input_scrollbar" :settings="settings">
                                    <div id="descricao">
                                        {{ form.descricao }}
                                    </div>
                                </vue-perfect-scrollbar>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="6" sm="6">
                            <b-form-group label="Status" label-for="status"
                                label-class="label_size_dose font-weight-bold">

                                <vue-perfect-scrollbar class="altura_max_textarea_scrollbar" :settings="settings">
                                    <div id="status" class="d-flex flex-wrap centralizar_responsivo">
                                        <div class="rounded status-box" :class="form.status ? 'ativo' : 'inativo'">
                                            {{ form.status ? 'Ativo' : 'Inativo' }}
                                        </div>
                                    </div>
                                </vue-perfect-scrollbar>

                            </b-form-group>
                        </b-col>
                        <b-col lg="6" md="6" sm="6">
                            <b-form-group label="Código" label-for="codigo"
                                label-class="label_size_dose font-weight-bold">
                                <vue-perfect-scrollbar class="altura_max_textarea_scrollbar" :settings="settings">
                                    <div id="codigo">
                                        {{ form.codigo }}
                                    </div>
                                </vue-perfect-scrollbar>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </section>
        </main>
    </div>
</template>

<script>
import { BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadio, BButton, BFormTextarea } from 'bootstrap-vue';
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue';
import ErrorModal from '@/views/components/custom/modals/ErroIdInexistenteModal.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { getIdDose } from '@core/utils/store/getStore';
import { setIdDose } from '@core/utils/store/setStore';

export default {
    title: 'Detalhes dose',

    components: {
        BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadio, BFormTextarea,
        BButton, PageHeader, ErrorModal, VuePerfectScrollbar
    },

    data() {
        return {
            settings: {
                maxScrollbarLength: 70,
                wheelSpeed: 0.2,
                wheelPropagation: false
            },
            linkItems: [
                {
                    name: 'Doses',
                    routeName: 'dose-list'
                },
                {
                    name: 'Dose',
                    active: true
                }
            ],
            modalError: {
                showModal: false,
                typeModal: 'error',
                caseModal: 'idInexistente'
            },
            form: {
                descricao: '',
                codigo: '',
                status: '',
            },
            idDoseShow: null
        }
    },

    mounted() {
        if ((getIdDose() === null || typeof getIdDose() == 'undefined') && typeof this.$route.params.idDose == "undefined") {
            return this.openModalError();
        } else if (typeof this.$route.params.idDose != "undefined" && this.$route.params.idDose !== getIdDose()) {
            setIdDose(this.$route.params.idDose);
        }

        this.$http.get(this.$api.doseWithParameter(getIdDose())).then(({ data }) => {
            this.preenchimentoFormulario(data);
        });
    },

    methods: {
        preenchimentoFormulario(data) {
            this.idDoseShow = data.id_dose;
            this.form.descricao = data.descricao;
            this.form.codigo = data.br_dose;
            this.form.status = data.ativo;
            this.linkItems[1].name = data.descricao;
        },

        redirectToEdit() {
            this.$router.push(
                {
                    name: 'dose-edit',
                    params: {
                        idDose: getIdDose()
                    }
                }
            );
        },

        redirecionarLista() {
            this.$router.push({ name: 'dose-list' });
        },

        openModalError() {
            this.modalError.showModal = true;
        },
    }
}
</script>

<style scoped>
.status-box {
    padding: 5px 10px;
    margin-right: 10px;
    font-weight: 500;
    color: white;
    min-width: 80px;
    text-align: center;
}

.top-right-button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 10;
}

.ativo {
    background-color: #28c76f;
}

.inativo {
    background-color: #ea5455;
}

.altura_max_input_scrollbar {
    max-height: 32px;
    word-break: break-all;
    padding-right: 15px;
}

.altura_max_textarea_scrollbar {
    max-height: 113px;
    word-break: break-all;
    padding-right: 15px;
}

@media (max-width: 767px) {
    .centralizar_responsivo {
        text-align: center;
        justify-content: center;
    }
}
</style>